import { render } from "./EventoDialog.vue?vue&type=template&id=4e0f7c04"
import script from "./EventoDialog.vue?vue&type=script&lang=js"
export * from "./EventoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__